import { Giorno } from 'app/model/time';
import { Subscription} from 'rxjs/Subscription';
import { Settimana } from 'app/model/time';
import { Agenda } from 'app/model/agenda';
import { Component, OnDestroy, Input } from '@angular/core';
import * as moment from 'moment';

const dayClasses = [
	'fc-mon', 
	'fc-tue', 
	'fc-wed', 
	'fc-thu', 
	'fc-fri', 
	'fc-sat', 
	'fc-sun'
];

// TODO: eliminare dipendenza da jQuery
class StyleComponent implements OnDestroy {
	
	protected readonly sheet: CSSStyleSheet;
	protected subscriptions: Subscription[] = [];
	private htmlReference: JQuery<HTMLElement>;

	constructor() {
		this.htmlReference = $("<style>").appendTo("head");
		this.sheet = this.htmlReference.prop("sheet") as CSSStyleSheet;
	}

	protected unsubscribe() {
		for(let s of this.subscriptions) {
			s.unsubscribe();
		}

		this.subscriptions = [];
	}

	protected clear() {
		this.unsubscribe();
		
		while(this.sheet.cssRules.length) {
			this.sheet.deleteRule(this.sheet.cssRules.length - 1);
		}
	}

	ngOnDestroy(): void {
		this.clear();
		this.htmlReference.remove();
	}
}

@Component({
	selector: 'app-settimana-style',
	template: '',
	styleUrls: [ ]
})
export class SettimanaStyleComponent extends StyleComponent {

	constructor() {
		super();
	}

	@Input()
	set settimana(value: Array<Giorno>|Settimana) { 
		this.clear();
		if(value) {
			let week: moment.Moment;
			
			if('settimana' in value) {
				week = moment(value.settimana);
			}

			this.subscriptions = value.map((giorno, i) => {
				const day = dayClasses[i];
				const rule = this.sheet.cssRules[
					this.sheet.insertRule(
						week ? 
							`.fc-month-view [data-date="${week.clone().add(i, 'day').format("YYYY-MM-DD")}"].fc-day.${day} { }` :
							`.fc-month-view .fc-day.${day} { }`, 
						this.sheet.cssRules.length
					)
				] as CSSStyleRule;

				return giorno.subscribe(intervalli => {
					if(intervalli.length) {
						rule.style.background = 'transparent';
					} else {
						rule.style.background = '#d7d7d755';
					}
				});
			});
		}
	}
}

@Component({
  selector: 'app-calendar-style',
  templateUrl: './calendar-style.component.html',
  styleUrls: [ ]
})
export class CalendarStyleComponent {

	@Input()
	agenda: Agenda;

}



// WEBPACK FOOTER //
// ./src/app/calendar/calendar-style/calendar-style.component.ts